import React, { useState } from 'react';

import { useUser } from 'hooks';

import * as Form from 'components/form';
import * as Page from 'components/page';
import * as Alert from 'components/alert';
import { isValidEmail } from 'utils/validation';
// import { CorporationCard } from '../components/corporation/CorporationCard';
import * as Styled from './StyledEcosystemStep3AddForm';

export function EcosystemStep3AddForm(props) {
    const user = useUser();
    const { form, onSubmit } = props;
    const [validDomain, setValidDomain] = React.useState(true);
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [renderWarning, setRenderWarning] = useState(false);

    // Create form fields object
    const fields = {
        companyContactName: {
            error: form.errors.companyContactName,
            label: props.t('companyContactName'),
            name: 'companyContactName',
            type: 'text',
            value: form.values.companyContactName,
            onChange: form.handleChange,
        },
        companyContactEmail: {
            error: form.errors.companyContactEmail,
            label: props.t('companyContactEmail'),
            name: 'companyContactEmail',
            type: 'email',
            value: form.values.companyContactEmail,
            onBlur: ev => {
                const domain = (ev.target.value || '').split('@')[1];

                if (!domain || !isValidEmail(ev.target.value)) {
                    return setValidDomain(false);
                    // return addVars({ searchedCompany: {} });
                } else {
                    return setValidDomain(true);
                }

                // return getCompanyByDomain(domain).then(res => {
                //     if (res.validdomain) {
                //         setValidDomain(true);
                //         return;
                //     }
                //     setValidDomain(false);
                // });
            },
            onChange: form.handleChange,
        },

        companyConfirmationEmail: {
            error: form.errors.companyConfirmationEmail,
            label: props.t('companyContactEmail2'),
            name: 'companyConfirmationEmail',
            type: 'email',
            value: form.values.companyConfirmationEmail,
            onChange: form.handleChange,
        },

        ecosystemCompanyName: {
            error: form.errors.ecosystemCompanyName,
            label: props.t('ecossystemCompanyName'),
            name: 'ecosystemCompanyName',
            type: 'text',
            value: form.values.ecosystemCompanyName,
            onChange: form.handleChange,
            readOnly: user?.company?.id,
        },
        programName: {
            error: form.errors.programName,
            label: props.t('glossary:programName'),
            name: 'programName',
            type: 'text',
            value: form.values.programName,
            onChange: form.handleChange,
        },
        description: {
            error: form.errors.description,
            label: props.t('glossary:description'),
            name: 'description',
            required: false,
            type: 'textarea',
            value: form.values.description,
            onChange: form.handleChange,
        },
        year: {
            displayFormat: 'YYYY',
            error: form.errors.year,
            label: props.t('glossary:year'),
            maxLength: 4,
            name: 'year',
            type: 'text',
            value: form.values.year,
            onChange: form.handleChange,
        },
        linkUrl: {
            error: form.errors.linkUrl,
            label: props.t('glossary:linkUrl'),
            name: 'linkUrl',
            type: 'text',
            required: false,
            value: form.values.linkUrl,
            onChange: form.handleChange,
        },
    };

    // validate if email is equal, If not, renders the Alert
    // const corpEmail = fields.companyContactEmail.value;
    // const companyConfirmationEmail = fields.companyConfirmationEmail.value;

    const propsAlert = {
        descr: props.t('glossary:emailConfirmationError'),
        icons: 'far fa-exclamation-circle',
        type: 'warning',
        color: 'red',
    };

    // Handle form submition
    const evSubmit = ev => {
        ev.persist();
        ev.preventDefault();
        // if (companyConfirmationEmail === corpEmail) {
        //     setIsEmailValid(true);
        // }
        if (!isEmailValid) {
            setRenderWarning(true);
            return false;
        }
        return form.handleSubmit(ev, onSubmit);
    };

    return (
        <Form.Form name="EcosystemStep3AddForm" onSubmit={evSubmit}>
            <Form.Field {...fields.companyContactName} />
            <Form.Field {...fields.companyContactEmail} />
            <Form.Field {...fields.companyConfirmationEmail} />

            {renderWarning && <Alert.AlertRow {...propsAlert} />}

            {!validDomain && (
                <Styled.FieldError className="domain-error">
                    {props.t('StartupStep8Add.domainError')}
                </Styled.FieldError>
            )}

            {/* {searchedCompany?.company && (
                <Page.Boxed style={{ marginTop: '2rem' }}>
                    {!!Object.keys(searchedCompany?.company).length && (
                        <>
                            <CorporationCard
                                {...form.values}
                                useRankingEcosystem={props.useRankingEcosystem}
                            />
                        </>
                    )}
                </Page.Boxed>
            )} */}

            <Page.Ruler />

            <Form.Field {...fields.ecosystemCompanyName} />
            <Form.Field {...fields.programName} />
            <Form.Row>
                <Form.Field size="4" {...fields.year} />
                <Form.Field size="8" {...fields.linkUrl} />
            </Form.Row>
            <Form.Field {...fields.description} />

            <Form.Submt
                {...form}
                text={props.t('glossary:save')}
                disabled={!validDomain || !isEmailValid}
            />
        </Form.Form>
    );
}
export default EcosystemStep3AddForm;
